






















import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { bookCatalog, bookSeries, getBooks, recordBook } from './../model/api'
import { Book } from './../model/book_model'

@Component
export default class BookCascader extends Vue {
  public get subjectId() {
    return this.$store.state.subject.value
  }
  public get subject() {
    return this.$store.state.subject
  }
  public get defaultBook() {
    return this.$store.state.question.defaultbook
  }
  public onChange() {}
  // public options = []
  public books: Book[] = []
  public loadData(selectedOptions) {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
    setTimeout(() => {
      targetOption.loading = false
      targetOption.children = [
        {
          label: `${targetOption.label} Dynamic 1`,
          value: 'dynamic1'
        },
        {
          label: `${targetOption.label} Dynamic 2`,
          value: 'dynamic2'
        }
      ]
      this.books = [...this.books]
    }, 1000)
  }
  public async getBookSeries() {
    let { data } = await bookSeries({ subject_id: this.subjectId })
    this.books = data
  }

  @Watch('subjectId')
  public onSubjectChange(val) {
    this.getBookSeries()
  }
}
